import Vue from 'vue'
import { VueRouter } from 'vue-router/types/router'
import VueGtag from 'vue-gtag'

import { pinia } from '@/common/stores'
import vuetify from '@/app/plugins/vuetify'
import '@/app/components/index'

import i18n from '@/app/lang'
import env from '@/env/env'

import App from '@/app/App.vue'

export function createApp (router: VueRouter) {
    if (typeof window !== 'undefined') {
        Vue.use(VueGtag, {
            appName: 'Radio1.7',
            config: {
                id: env.googleAnalyticsId
            },
            enabled: false,
            pageTrackerScreenviewEnabled: true
        }, router)
    }

    const app = new Vue({
        render: h => h(App),
        router,
        pinia,
        vuetify,
        i18n
    })

    return { app }
}
